import { Timesheetapi } from "../../middleware/interceptor"


export const ErrorLog = async (payload) => {


    try {
        const createLog = await Timesheetapi.post(`api/Projects/PutErrors`, payload);

        return createLog.data;
    } catch (error) {
        console.log(error);
    }

}